module.exports = __webpack_public_path__ + "static/media/Mentorship.b96c03e7.svg";